import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    entity: null
};

const requestActivities365Report = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveActivities365Report = (state, action) => {
    return {
        ...state,
        entity: action.activities365Report.userMetrics ? action.activities365Report.userMetrics[0] : {},
        isFetching: false,
        lastUpdated: action.receivedAt
    };
};

const resetToInitialState = () => INITIAL_STATE;

const handlers = {
    [types.REQUEST_ACTIVITIES_365_REPORT]: requestActivities365Report,
    [types.RECEIVE_ACTIVITIES_365_REPORT]: receiveActivities365Report,
    [types.RESET_ACTIVITIES_365_REPORT]: resetToInitialState
};

export const getActivities365Report = (state) => {
    return state.activities365Report.entity;
};

export const fetchingActivities365Report = (state) => {
    return state.activities365Report.isFetching;
};

export default function activities365Report(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
